export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./InstructionView.vue?vue&type=template&id=22f6c8ee"


//////////////////
// WEBPACK FOOTER
// ./src/views/InstructionView.vue?vue&type=template&id=22f6c8ee
// module id = 303
// module chunks = 16